'use client';

import { useRouter } from 'next/navigation';
import { Card, Col, Image } from 'react-bootstrap';

export default function ItemVenue({ data = [] }) {
  const router = useRouter();

  return (
    <>
      {data.map((item, index) => (
        <Col lg={4}
          className={`item-venue item-venue-${item.path}`}
          onClick={() => router.push(`/${item.path}`)}
          key={index}
          style={{ cursor: 'pointer' }}
        >
          <div className='shadow'></div>
          <Card className="card-parallelogram">
            <Card.Body className="p-0">
              <Image src={item.image} alt={item.title} fluid />
            </Card.Body>
          </Card>
          {/* <p className="text-gold fw-bold mb-0">{item.title}</p> */}
        </Col>
      ))}
    </>
  );
}
